export default __webpack_public_path__ + "static/media/AQ.1e3b1169.svg";